import { cx } from "../../lib/cx.js";
import { Text } from "../Text/Text.js";
/* empty css                */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ColorSwatch/ColorSwatch.tsx
/**
* A colour, display only: a round chip filled with it beside its hex value. The value
* carries the information, so the chip is decorative.
*/
function ColorSwatch({ value, label, className, ...rest }) {
	return /* @__PURE__ */ jsxs("span", {
		className: cx("ds-color-swatch", className),
		...rest,
		children: [
			/* @__PURE__ */ jsx("span", {
				className: "ds-color-swatch__chip",
				style: { background: value },
				"aria-hidden": "true"
			}),
			label && /* @__PURE__ */ jsx("span", { children: label }),
			/* @__PURE__ */ jsx(Text, {
				mono: true,
				children: value
			})
		]
	});
}
//#endregion
export { ColorSwatch };

//# sourceMappingURL=ColorSwatch.js.map